import * as React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import styles from "./Table.module.scss";
import NoRowsMessage from "./NoRowsMessage";
import { isEmptyArray } from "formik";
interface PaginatedDataTableProps<T> {
  rows: any[];
  columns: GridColDef[];
  totalRows?: number;
  initialPage: number;
  pageSize: number;
  handlePageChange?: (pageNumber: number) => void;
  handleSortChange?: (field: string, sortDescending: boolean) => void;
  handleRowClick?: (row: T) => void;
  emptyMessage: string;
  loading: boolean;
  autoHeight?: boolean | undefined;
  rowAutoHeight?: boolean | undefined;
}

export function PaginatedDataTable<T>({
  rows,
  totalRows,
  columns,
  initialPage,
  pageSize,
  loading,
  handlePageChange,
  handleSortChange,
  handleRowClick,
  emptyMessage,
  autoHeight,
  rowAutoHeight,
  
}: PaginatedDataTableProps<T>) {
  return (
    <div className={styles.dataTable + " " + (pageSize > 5 ? styles.full : styles.normal) + " " + (autoHeight ? styles.autoHeight : "")}>
      <DataGrid
        components={{
          NoRowsOverlay: () => <NoRowsMessage emptyMessage={emptyMessage} />,
        }}
        hideFooterPagination={totalRows === 0}
        headerHeight={28}
        rowHeight={40}
        rows={rows}
        columns={columns}
        page={initialPage}
        loading={loading}
        pageSize={pageSize}
        rowsPerPageOptions={[pageSize]}
        disableColumnFilter
        disableColumnMenu
        disableSelectionOnClick
        disableColumnSelector
        paginationMode="server"
        sortingMode="server"
        rowCount={totalRows}
        onSortModelChange={(model) => {
          if (!isEmptyArray(model)) {
            if (handleSortChange) {
              const sortDescending = model[0].sort === "desc";
              handleSortChange(model[0].field, sortDescending);
            }
          }
        }}
        onRowClick={(params) => {
          if (handleRowClick) handleRowClick(params.row);
        }}
        onPageChange={(page) => {
          if (handlePageChange) handlePageChange(page + 1);
        }}
        autoHeight={autoHeight}
        getRowHeight={rowAutoHeight ? () => "auto" : undefined}
      />
    </div>
  );
}

interface DataTableProps<T> {
  rows: any[];
  columns: GridColDef[];
  handleRowClick?: (row: T) => void;
  emptyMessage: string;
  loading: boolean;
  autoHeight?: boolean | undefined;
  rowAutoHeight?: boolean | undefined;
  pageSize?: number | undefined;
}

export default function DataTable<T>({
  rows,
  columns,
  handleRowClick,
  emptyMessage,
  loading,
  autoHeight,
  rowAutoHeight,
  pageSize,
}: DataTableProps<T>) {
  return (
    <div
      className={`${styles.dataTable} ${autoHeight ? styles.autoHeight : ""} ${rows.length === 0 ? styles.empty : ""}`}
    >
      <DataGrid
        components={{
          NoRowsOverlay: () => <NoRowsMessage emptyMessage={emptyMessage} />,
        }}
        headerHeight={28}
        rowHeight={40}
        getRowHeight={rowAutoHeight ? () => "auto" : undefined}
        rows={rows}
        columns={columns}
        pageSize={pageSize || 5}
        loading={loading}
        rowsPerPageOptions={[]}
        hideFooterPagination
        disableColumnFilter
        disableColumnMenu
        disableSelectionOnClick
        disableColumnSelector
        onRowClick={(params) => {
          if (handleRowClick) handleRowClick(params.row);
        }}
        autoHeight={autoHeight}
      />
    </div>
  );
}
